import { v4 as uuidv4 } from "uuid";

import { SaveResponse } from "../../models/api/save/save.response";
import { DocumentRef } from "../../models/documents";
import { TransactionRef } from "../../models/transactions";
import { TransactionDocumentSTO } from "../../models/transactions-documents";
import { TransactionsDocumentsApiService } from "../../services/transactions-documents/transactions-documents-api.service";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";

export const saveLinkEntity = async (
  linkedEntityName: "document" | "transaction",
  linkedEntity: DocumentRef | TransactionRef,
  entityToLinkName: "document" | "transaction",
  entityToLink: DocumentRef | TransactionRef | null
): Promise<SaveResponse> => {
  const response = await new TransactionsDocumentsApiService().saveItems([
    {
      id: uuidv4(),
      isDeleted: false,
      document: linkedEntityName === "document" ? linkedEntity : entityToLinkName === "document" ? entityToLink : null,
      transaction:
        linkedEntityName === "transaction" ? linkedEntity : entityToLinkName === "transaction" ? entityToLink : null,
    } as TransactionDocumentSTO,
  ]);

  toastifyResponse(response);

  return response;
};
